import React from 'react'
import Avatar from 'react-avatar-edit'
import { Image, Button, Table, Grid, Header } from 'semantic-ui-react'

export default class AvatarEditor extends React.Component {

  state = {
    src: null,
    preview: null,
    open:false
  }

  componentWillMount() {
    this.setState({ src: this.props.src, open:true });
  }
  componentDidMount() {
    this.setState({ src: this.props.src, open:true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.src !== this.props.src) {
      this.setState({ src: this.props.src })
    }
  }

  handleCrop = (preview) => { console.log('preview', preview); this.setState({ preview }) }
  handleClose = ()  => this.setState({open: false});


  handleUploadClick = (e) => {
    e.preventDefault()
    if (!this.state.preview) return;
    const blobBin = atob(this.state.preview.split(',')[1]);
    const array = [];
    for(let i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
    }
    const file = new Blob([new Uint8Array(array)], {type: 'image/png'});
    const formData = new FormData();
    formData.append('userToken', this.props.userToken);
    formData.append('avatar', file);

    fetch('/upload', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then((res) => this.props.onAvatarUploaded(res.path))
      .catch(err => console.error(err))
  }

  render() {
    if (!this.state.open) return null; 
    return <div style={{display: 'flex', alignItems: 'center'}}>
      <Table celled textAlign='center' padded style ={{
                  bordertop: '10', borderleft:'10'

      }}> 
      <Table.Row textAlign='center'>
      <Table.HeaderCell colspan ={2}><Header color = 'yellow'>Upload Avatar</Header></Table.HeaderCell>
      </Table.Row>
      <Table.Row textAlign='center'>
        <Table.HeaderCell><Header color = 'purple'>Vecchio Avatar</Header></Table.HeaderCell>
        <Table.HeaderCell><Header color = 'purple'>Nuovo Avatar</Header></Table.HeaderCell>
      </Table.Row>
      <Table.Body>
      <Table.Row textAlign='center'>
        <Table.Cell textAlign='center' style={{background:'#2B2D2F'}}>
        <Image src={this.state.src} width={258} />
        </Table.Cell>
        <Table.Cell style={{background:'#35373a'}}>
        <Avatar  onCrop={this.handleCrop} width={389} height={259} label = 'Clicca qui per scegliere un file' />
        </Table.Cell>
      </Table.Row>
      <Table.Row textAlign='center'>
        <Table.Cell colspan = {2}>
          <Grid>
          <Grid.Row>
          <Grid.Column width={8}>
          <Button fluid positive onClick={this.handleUploadClick}>Carica</Button>
          </Grid.Column>
            <Grid.Column width={8}>
          <Button fluid negative onClick={this.handleClose}> Chiudi</Button>
          </Grid.Column>
          </Grid.Row>
          </Grid>
        </Table.Cell>
      </Table.Row>
    </Table.Body>
      </Table>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/AvatarEditor.js